export default function Footer(props) {
  return (
    <footer>
      <div className="mastfoot">
        <div className="fst-italic py-3" style={{maxWidth:'1000px', margin:'auto'}}>Personal information contained on this form is collected pursuant to the Municipal Freedom of Information and Protection of Privacy Act and will be used for the purpose of responding to your request. Questions about this collection should be directed to the Access and Privacy Officer at <a href="mailto:access.privacy@york.ca">access.privacy@york.ca</a></div>
      </div>
    </footer>
  );
}